<div class="sidebar" [class.open]="open$ | async">

  @if(data$ | async; as data) {

    @if(data.contact) {
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-2 p-0"><fa-icon [icon]="faX" (click)="onSidebarToggle()" class="header-text cursor-pointer"></fa-icon></div>
          <div class="col-md-10 p-0 text-end">
            <fa-icon
              [icon]="faPencil"
              (click)="onNavigate(data.navigate_edit); $event.stopPropagation()"
              (contextmenu)="onContextMenu($event, data)"
              size="sm"
              class="text-danger cursor-pointer"
              title="Ansprechpartner bearbeiten"
            >
            </fa-icon>
          </div>
        </div>
        <div class="row mt-5">
          <div class="container">
            <div class="row d-flex align-items-center">
              <div class="col p-0 d-flex justify-content-center align-items-center" style="height: 150px;">
                <div class="avatar p-3 d-flex justify-content-center align-items-center">
                  <fa-icon [icon]="faUser" class="icon"></fa-icon>
                </div>
              </div>
            </div>
            <div class="row mt-4 d-flex align-items-center">
              <div class="col text-center header-text">
                <div class="bold">{{data.contact?.first_name}} {{data.contact?.last_name}}</div>
                <div>{{data.contact?.position}}</div>
                <div>{{data.contact?.employer?.name || data.contact?.employer?.pseudonym}}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="row mt-5 header-text">
          <div class="container-fluid">
            <div class="row my-2">
              <div class="col-md-2 p-0">E-Mail:</div>
              <div class="col-md-10 p-0 text-end text-danger contact-info">
                @if(data.contact?.email) {
                  <a href="javascript:void(0)" class="mail text-decoration-none text-danger" href="mailto:{{data.contact?.email}}">{{data.contact?.email}}</a>
                }
              </div>
            </div>
            <div class="row my-2">
              <div class="col-md-2 p-0">Tel:</div>
              <div class="col-md-10 p-0 text-end text-danger contact-info">
                @if(data.contact?.phone) {
                  <a href="javascript:void(0)" class="mail text-decoration-none text-danger" href="tel:{{data.contact?.phone}}">{{data.contact?.phone}}</a>
                }
              </div>
            </div>
            <div class="row my-2">
              <div class="col-md-2 p-0">Mobil:</div>
              <div class="col-md-10 p-0 text-end text-danger contact-info">
                @if(data.contact?.mobile) {
                  <a href="javascript:void(0)" class="mail text-decoration-none text-danger" href="tel:{{data.contact?.mobile}}">{{data.contact?.mobile}}</a>
                }
              </div>
            </div>
            <div class="row my-2">
              <div class="col-md-2 p-0">Fax:</div>
              <div class="col-md-10 p-0 text-end text-danger contact-info">
                @if(data.contact?.fax) {
                  <a href="javascript:void(0)" class="mail text-decoration-none text-danger" href="tel:{{data.contact?.fax}}">{{data.contact?.fax}}</a>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    }
  }
</div>

<!-- Context Menu für Ansprechpartner bearbeiten -->
<div style="visibility: hidden; position: fixed;"
     [style.left.px]="contextMenuPosition.x"
     [style.top.px]="contextMenuPosition.y"
     [matMenuTriggerFor]="contextMenu"
     #companyMenuTrigger="matMenuTrigger">
</div>

<mat-menu #contextMenu="matMenu" class="context-menu">
  <ng-container *ngFor="let action of getVisibleContextActions(); let isLast = last">
    <button mat-menu-item
            type="button"
            [disabled]="action.isDisabled"
            (click)="executeContextAction(action, $event)">

      <span *ngIf="action.icon && getIconFontSet(action.icon)"
            [class]="'fa fa-' + action.icon"
            class="context-menu-icon"></span>

      <mat-icon *ngIf="action.icon && !getIconFontSet(action.icon)"
                class="context-menu-icon">{{ action.icon }}</mat-icon>

      <span>{{ action.label }}</span>
    </button>

    <mat-divider *ngIf="action.divider && !isLast"></mat-divider>
  </ng-container>
</mat-menu>
